import MasterDataProductCreatePage from "@/features/master-data/pages/MasterDataProductCreate";

const MasterDataProductCreate = () => {
  return <MasterDataProductCreatePage />;
};

export default MasterDataProductCreate;
